module.exports = __webpack_public_path__ + "static/img/SellTime.469384b2.svg";